// Dropdowns
const purchaseDropdowns = document.querySelectorAll('.purchase-process-dropdown.is-radio');
const submitButton = document.querySelector('#sc-purchase-process-info-02 [type="submit"]');

// Parse "1.234,56 €" / "Free" / "from 4,99€" into a number
const parsePrice = (text) => {
  const match = text?.match(/-?[\d.,]+/);

  if (!match) return 0;

  return parseFloat(match[0].replace(/\./g, '').replace(',', '.')) || 0;
};

const formatPrice = (amount) => `${amount.toFixed(2).replace('.', ',')} €`;

const updateFinalPrice = (shippingAmount) => {
  const finalPriceEl = document.querySelector('.purchase-process-sidebar__final .purchase-process-sidebar__final-right');
  const subtotalPriceEl = document.querySelector('.purchase-process-sidebar__sub-total .purchase-process-sidebar__savings-right');
  if (!finalPriceEl || !subtotalPriceEl) return;

  finalPriceEl.textContent = formatPrice(parsePrice(subtotalPriceEl.textContent) + shippingAmount);
};


const toggleDropdown = (dropdownParent, isOpen) => {
  const dropdown = dropdownParent.querySelector('.purchase-process-dropdown__drop');

  dropdownParent.classList.toggle('is-open', isOpen);

  if (isOpen) {
    slideDown(dropdown, 300, 'flex');
  } else {
    slideUp(dropdown, 300, 'none');
  }
};

const checkFirstVisibleItem = (container) => {
  const firstItem = container.querySelector('.purchase-process-dropdown__item:not([hidden]) input');

  if (firstItem) {
    firstItem.checked = true;
    firstItem.dispatchEvent(new Event('change', { bubbles: true }));
  }
};

purchaseDropdowns.forEach((purchaseDropdown) => {
  const parent = purchaseDropdown.closest('.purchase-process-dropdowns__item');
  const otherDropdowns = parent.querySelectorAll('.purchase-process-dropdown.is-dropdown');
  const headerInput = purchaseDropdown.querySelector('.purchase-process-dropdown__header input');

  headerInput.addEventListener('change', (ev) => {
    // Close all dropdowns first
    otherDropdowns.forEach((dropdown) => {
      toggleDropdown(dropdown, false);
    });

    const dropdownParent = ev.target.closest('.purchase-process-dropdown.is-dropdown');

    if (!ev.currentTarget.checked) {
      return;
    }

    if (!purchaseDropdown.classList.contains('purchase-process-dropdown--payment')) {
      const priceEl = ev.currentTarget.closest('.checkbox')?.querySelector('.checkbox__info-price');
      const shippingPriceEl = document.querySelector('.purchase-process-sidebar__shipping .purchase-process-sidebar__savings-right');

      if (priceEl && shippingPriceEl) {
        const shippingAmount = parsePrice(priceEl.textContent);

        shippingPriceEl.textContent = priceEl.textContent.trim();
        updateFinalPrice(shippingAmount);
      }
    }

    if (!dropdownParent) {
      return;
    }

    submitButton?.classList.add('is-loading');

    const isCreditCard = ev.currentTarget.id === 'credit-card';
    const delay = isCreditCard ? 900 : 400;

    const dropdown = dropdownParent.querySelector('.purchase-process-dropdown__drop');

    if (!isCreditCard) {
      checkFirstVisibleItem(dropdown);
    }

    setTimeout(() => {
      toggleDropdown(dropdownParent, true);
      submitButton?.classList.remove('is-loading');
    }, delay);
  });
});

// Check when inputs fail
const observeInputFail = () => {
  const dropdownInputs = document.querySelectorAll('.input-group .mod-input');

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(({ target, type, attributeName }) => {
      if (type === 'attributes' && attributeName === 'class') {
        target
          .closest('.input-group')
          ?.classList.toggle('is-failed', target.classList.contains('is-validation-failed'));
      }
    });
  });

  dropdownInputs.forEach((input) => {
    observer.observe(input, {
      attributes: true,
      attributeFilter: ['class'],
    });
  });
};

observeInputFail();

// Hide "cash on delivery" payment option when store pickup delivery is selected
const storePickupTrigger = document.querySelector('[data-modal-trigger][data-id="find-store-modal"]');
const storePickupInput = storePickupTrigger?.closest('.checkbox')?.querySelector('input[type="radio"]');
const cashMoneyInput = document.querySelector('#cash-money');
const cashMoneyOption = cashMoneyInput?.closest('.purchase-process-dropdown');

if (storePickupInput && cashMoneyInput && cashMoneyOption) {
  const toggleCashMoneyOption = () => {
    const isStorePickup = storePickupInput.checked;

    cashMoneyOption.classList.toggle('hide', isStorePickup);

    if (isStorePickup && cashMoneyInput.checked) {
      cashMoneyInput.checked = false;
      cashMoneyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  document.querySelectorAll(`input[name="${storePickupInput.name}"]`).forEach((input) => {
    input.addEventListener('change', toggleCashMoneyOption);
  });

  toggleCashMoneyOption();
}

// ------

const storePickupCard = document.querySelector('.store-pickup-item');
const parcelLockerCard = document.querySelector('.parcel-locker-item');

attachEvent('.store-card', 'click', (ev) => {
  const parent = ev.target.closest('.store-card');
  const title = parent.querySelector('.store-card__title');
  const text = parent.querySelector('.store-card__text');

  const isStorePickup = ev.target.closest('.find-store-modal');
  const isParcelLocker = ev.target.closest('.parcel-locker-modal');

  let currentCard = null;

  if (isStorePickup) {
    currentCard = storePickupCard;
  }

  if (isParcelLocker) {
    currentCard = parcelLockerCard;
  }

  if (currentCard) {
    const checkboxInfo = currentCard.querySelector('.checkbox__info');
    const checkboxRight = currentCard.querySelector('.checkbox__right');
    const input = currentCard.querySelector('input');

    // check input
    if (input) {
      input.value = parent.dataset.store;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // remove old generated items only
    checkboxInfo.querySelectorAll('.checkbox__info-item:not(.checkbox__info-edit)').forEach((item) => item.remove());

    const titleEl = document.createElement('em');
    titleEl.className = 'checkbox__info-item';
    titleEl.innerHTML = title.innerHTML;

    const textEl = document.createElement('em');
    textEl.className = 'checkbox__info-item';
    textEl.innerHTML = text.innerHTML;

    checkboxInfo.prepend(textEl);
    checkboxInfo.prepend(titleEl);

    checkboxInfo.classList.remove('hide');
    checkboxRight.classList.add('hide');
  }

  toggleModal(ev.target, false);
});
